import React, { useState } from 'react';
import { supabase } from './supabaseClient'; // Adjust path if needed
import './Login.css';

export default function Login({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false); // Toggle between Login and Signup
  const [error, setError] = useState(null);

  const handleAuth = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      if (isSignUp) {
        // Handle Sign Up
        const { error } = await supabase.auth.signUp({
          email,
          password,
        });
        if (error) throw error;
        alert('Registration successful! Check your email for verification (if enabled) or log in.');
        setIsSignUp(false); // Switch back to login view
      } else {
        // Handle Login
        const { error } = await supabase.auth.signInWithPassword({
          email,
          password,
        });
        if (error) throw error;
        // If successful, the parent component (App.js) will detect the session change
        if (onLoginSuccess) onLoginSuccess();
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div style={{ marginBottom: '20px' }}>
          <a 
            href="https://nsb.ac.in" 
            target="_blank" 
            rel="noopener noreferrer"
            title="Visit NTPC School of Business"
          >
            <img 
              src="/nsb_logo.png" 
              alt="NTPC School of Business" 
              style={{ maxWidth: '180px', height: 'auto', cursor: 'pointer' }} 
            />
          </a>
        </div>
        <div className="login-header">
          <h2>DEA Analysis Tool</h2>
          <p>{isSignUp ? 'Create an account to get started' : 'Log in to access your datasets'}</p>
        </div>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleAuth} className="login-form">
          <div className="input-group">
            <label>Email Address</label>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Processing...' : (isSignUp ? 'Sign Up' : 'Log In')}
          </button>
        </form>

        <div className="toggle-text">
          {isSignUp ? 'Already have an account?' : "Don't have an account?"}
          <span 
            className="toggle-link" 
            onClick={() => {
              setIsSignUp(!isSignUp);
              setError(null);
            }}
          >
            {isSignUp ? 'Log In' : 'Sign Up'}
            
          </span>
        </div>
      </div>
    </div>
  );
}